import { createContext } from 'react';

type ArchivedChoices = 'active' | 'archived';

interface IContactsViewContext {
    archivedInput: ArchivedChoices;
    setIsArchived: (value: ArchivedChoices) => void;
}

const ContactsViewContext = createContext<IContactsViewContext>({
    archivedInput: 'active',
    setIsArchived: () => {},
});

export { ContactsViewContext };
export type { ArchivedChoices };
